import React from 'react';

const LogoSmallIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "26",
    height: "26",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" },
    className
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M25.3684 0.631592V25.3684H16.5731L16.6295 16.6685C16.6319 16.3031 16.4726 15.9554 16.1943 15.7186L13.4004 13.3408C13.1696 13.1443 12.8303 13.1442 12.5993 13.3404L9.80003 15.7181C9.52099 15.9552 9.36129 16.3037 9.36394 16.6698L9.42691 25.3684H0.631592V0.635406H9.42691V9.81849H16.5731V0.631592H25.3684Z",
      fill: "#B9BDC7"
    }
  )
);
LogoSmallIcon.displayName = "Icons.LogoSmallIcon";

export { LogoSmallIcon };
//# sourceMappingURL=LogoSmallIcon.js.map
